import { ref } from '@vue/composition-api'
import store from '@/store'
export default function pestStore() {

  const loading = ref(false)
  const errors = ref({})
  const comments = ref([])

  const blank_data = {
    type: 'pest',
    name: '',
    camp_id: null,
    device_id: null,
    work_areas: [{
      id: 1,
      start_period: null,
      end_period: null
    }],
    secondShift: false

  }


  const form = ref(Object.assign({}, blank_data))
  const fetchPlan = id => {
    store.dispatch('plans/fetchPlan', id).then(r => {

      Object.assign(form.value, r.data.plan, {
        work_areas: r.data.plan.data.work_areas,


      })

      delete form.value.data

    })
  }

  const fetchPlanComments = (params) => {
    store.dispatch('plans/getPlanComments', params).then(res => {
      console.log(reformatComments(res))
      comments.value = reformatComments(res);
    })

  }

  const reformatComments = (comments) => {
    let out = [];
    comments.map((item, index) => {
      out[index] = { commented_by: item.commented_by, comment: [item.created_at, item.comment] }
    })
    return out;
  }

  const submit = () =>


    new Promise((resolve, reject) => {
      loading.value = true
      errors.value = {}
      store.dispatch('plans/createPlan', form.value)
        .then(r => {
          Object.assign(form.value, blank_data)
          resolve(true)
        }).catch(reason => {
          if (reason.response.status === 422)
            errors.value = reason.response.data.errors
          reject(reason.response.data.message)
        }).finally(() => loading.value = false)
    })


  return {
    fetchPlanComments,
    loading,
    errors,
    comments,
    form,
    submit,
    fetchPlan

  }
}
